import {
  Table, Typography, TableRow, TableCell,
  TableBody,
} from '@mui/material';
import { getCurrentShow } from '@client/selectors/entities/shows';
import { useInstanceSelector, useSelector } from '@client/hooks/redux.hooks';
import { formatTotalAsCurrency } from '@sda/utils/lang';
import { pluralize } from '@sda/utils/string';
import { getShowTotalCalculator } from '@client/selectors/features/stripe';

export const OrderTable = () => {
  const show = useSelector(getCurrentShow);
  const total = useInstanceSelector(getShowTotalCalculator, show);

  return (
    <Table
      aria-label="order information"
      size="padded"
    >
      <TableBody>
        <TableRow>
          <TableCell>
            {pluralize('ticket', total.totalQuantity())}
          </TableCell>

          <TableCell align="right">
            {formatTotalAsCurrency(total.subTotal(), total.currency())}
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell>
            Processing fee
          </TableCell>

          <TableCell align="right">
            {formatTotalAsCurrency(total.totalFees(), total.currency())}
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell>
            Tax
          </TableCell>

          <TableCell align="right">
            {formatTotalAsCurrency(total.taxTotal() + total.sidedoorFeeTaxTotal(), total.currency())}
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell>
            <Typography
              variant="subtitle2"
              color="textSecondary"
            >
              Total
            </Typography>
          </TableCell>

          <TableCell align="right">
            <Typography
              variant="subtitle2"
              color="textSecondary"
            >
              {formatTotalAsCurrency(total.grossTotal(), total.currency())}
            </Typography>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
